import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  placeholder: string;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  name?: string;
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
}

interface StyledInputProps {
  helperText?: string;
}

const Datefield = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  required,
  helperText,
  disabled = false,
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <InputField
          disabled={disabled}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          name={name}
          helperText={helperText}
          autoComplete="off"
          type="date"
        />
        {helperText && <Error>{helperText}</Error>}
      </InputFieldWrapper>
    </>
  );
};

export const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const InputField = styled.input<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 12px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;
export const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

export const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default Datefield;
